
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"24","viewBox":"0 0 14 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.4292 3.30735L5.2212 12L13.429 20.6926C14.1875 21.4467 14.1904 22.6722 13.4355 23.4298C12.6804 24.1877 11.4533 24.1903 10.6948 23.4364L0.567349 13.37C-0.191519 12.6135 -0.187353 11.3822 0.569287 10.6281L10.695 0.563607C11.4536 -0.190361 12.6807 -0.187555 13.4357 0.570187C14.1906 1.32783 14.1877 2.55328 13.4292 3.30735Z"}})])
          )
        }
      }
    